import React from 'react';
import PropTypes from 'prop-types';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
import image from './images/image.jpg';

import './image-and-text.scss';

const ImageAndText = ({
  title,
  text,
  buttonText = 'Learn more',
  buttonURL = '/',
  imageSide = 'left',
  theme = 'white',
}) => (
  <section
    className={`image-and-text image-and-text_theme_${theme} image-and-text_image-side_${imageSide}`}
  >
    <div className="container image-and-text__inner">
      <div className="image-and-text__content">
        <Heading className="image-and-text__title" tag="h2" size="xl" innerHTML={title} />
        <div className="image-and-text__text" dangerouslySetInnerHTML={{ __html: text }} />
        {buttonText && buttonURL && (
          <Button to={buttonURL} theme="accent-primary">
            {buttonText}
          </Button>
        )}
      </div>
      <div className="image-and-text__image-wrapper">
        <img className="image-and-text__image" src={image} alt="" />
      </div>
    </div>
  </section>
);

ImageAndText.propTypes = {
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  buttonText: PropTypes.string,
  buttonURL: PropTypes.string,
  imageSide: PropTypes.oneOf(['left', 'right']),
  theme: PropTypes.oneOf(['white', 'gray']),
};


export default ImageAndText;
